// Styles
import 'styles/app'

// https://github.com/verlok/lazyload#conditional-load
// eslint-disable-next-line no-unexpected-multiline
(function (w, d) {
  var b = d.querySelector('body')
  var s = d.createElement('script')
  var v = !('IntersectionObserver' in w) ? '8.17.0' : '10.19.0'
  s.async = true
  s.src = 'https://cdn.jsdelivr.net/npm/vanilla-lazyload@' + v + '/dist/lazyload.min.js'
  b.appendChild(s)
})(window, document)

/*
 * Script loader
 *
 * Imports and runs all scripts in the `./scripts` directory
 * Scripts must have a default export with `can` and `run` functions
 *
 *    export default {
 *      can: () => boolean,
 *      run: function to run if `can` is true
 *    }
 */
document.addEventListener('DOMContentLoaded', () => {
  ((r) => {
    r.keys()
      .reduce((modules, script) => {
        const module = r(script).default
        module && modules.push(module)
        return modules
      }, [])
      .map((module) => (module.can === true || module.can()) && module.run())
  })(require.context('scripts', true, /^(?!.*(common|vue)).*\.js$/))
})
